export interface PagedResult<T> {
  docs?: T[];
  hasNext: boolean;
  next?: string;
  totalDocs?: number;
  totalFilteredCount?: number;
}
